import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

export const COMMERCIAL_TYPES = {
  office: "Büro",
  hall: "Halle",
  commercial: "Gewerbefläche",
  retail: "Ladenlokal",
  medical: "Praxisfläche",
  storage: "Lagerfläche",
  workshop: "Werkstatt",
  other: "Sonstige Einheit",
};
const RESIDENTIAL = ["apartment", "souterrain", "ground_floor", "floor_apartment", "maisonette", "attic", "penthouse"];
const KIND_TYPE = { 3: "cellar", 4: "storage", 5: "parking", 6: "parking", 7: "garage" };
const NUM = ["clear_height_m", "floor_load_kn_m2", "gate_count", "gate_height_m", "power_kw", "office_area", "hall_area", "outdoor_area", "workplaces"];
const BOOL = ["has_ramp", "has_crane", "has_kitchenette", "has_it_cabling", "has_air_conditioning"];

export const isCommercialType = (t) => !!COMMERCIAL_TYPES[t] && t !== "other";
export const isResidentialType = (t) => !t || RESIDENTIAL.includes(t);

// unit_type aus Einheitstyp (unit_kind) + Auswahl ableiten
export function deriveUnitType(form, existing) {
  const k = Number(form.unit_kind);
  if (k === 1) return isResidentialType(existing?.unit_type) ? existing?.unit_type || "apartment" : "apartment";
  if (k === 2) return form.unit_type && COMMERCIAL_TYPES[form.unit_type] ? form.unit_type : "commercial";
  return KIND_TYPE[k] || "other";
}

export function commercialFormFrom(u = {}) {
  const f = { unit_type: u.unit_type || "" };
  NUM.forEach((k) => { f[k] = u[k] ?? ""; });
  BOOL.forEach((k) => { f[k] = !!u[k]; });
  return f;
}

export function commercialPayload(form) {
  const p = {};
  NUM.forEach((k) => { p[k] = form[k] === "" || form[k] == null ? null : Number(form[k]); });
  BOOL.forEach((k) => { p[k] = !!form[k]; });
  return p;
}

// Bezeichnungen passend zur Einheitenart
export function unitLabels(unitType, unitKind) {
  const t = unitType || (Number(unitKind) === 2 ? "commercial" : "apartment");
  if (isResidentialType(t)) return { noun: "Wohnung", area: "Wohnfläche", rooms: "Zimmer" };
  if (t === "hall") return { noun: "Halle", area: "Nutzfläche", rooms: "Räume" };
  if (t === "office") return { noun: "Büro", area: "Bürofläche", rooms: "Räume" };
  if (t === "parking" || t === "garage") return { noun: t === "garage" ? "Garage" : "Stellplatz", area: "Fläche", rooms: "Plätze" };
  return { noun: COMMERCIAL_TYPES[t] || "Einheit", area: "Nutzfläche", rooms: "Räume" };
}

const N = ({ label, k, form, set, step = "0.1" }) => (
  <div><Label className="text-xs">{label}</Label>
    <Input type="number" step={step} value={form[k] ?? ""} onChange={(e) => set(k, e.target.value)} data-testid={`unit-${k}`} /></div>
);
const B = ({ label, k, form, set }) => (
  <label className="flex items-center gap-2 text-sm"><Checkbox checked={!!form[k]} onCheckedChange={(v) => set(k, !!v)} data-testid={`unit-${k}`} />{label}</label>
);

export function CommercialTypeSelect({ form, set }) {
  return (
    <div data-testid="unit-commercial-type-block">
      <Label className="text-xs">Einheitenart</Label>
      <select className="w-full h-9 border rounded-md px-2 text-sm bg-white" value={form.unit_type && COMMERCIAL_TYPES[form.unit_type] ? form.unit_type : "commercial"}
        onChange={(e) => set("unit_type", e.target.value)} data-testid="unit-commercial-type">
        {Object.entries(COMMERCIAL_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
      </select>
    </div>
  );
}

export function CommercialFields({ form, set }) {
  const t = form.unit_type || "commercial";
  return (
    <div className="space-y-3" data-testid="unit-commercial-fields">
      <div className="grid grid-cols-4 gap-3">
        {(t === "hall" || t === "workshop" || t === "storage") && <>
          <N label="Hallenfläche m²" k="hall_area" form={form} set={set} />
          <N label="Lichte Höhe (m)" k="clear_height_m" form={form} set={set} />
          <N label="Bodenlast (kN/m²)" k="floor_load_kn_m2" form={form} set={set} />
          <N label="Anzahl Tore" k="gate_count" form={form} set={set} step="1" />
          <N label="Torhöhe (m)" k="gate_height_m" form={form} set={set} />
          <N label="Anschlussleistung (kW)" k="power_kw" form={form} set={set} />
        </>}
        <N label="davon Bürofläche m²" k="office_area" form={form} set={set} />
        <N label="Freifläche / Hof m²" k="outdoor_area" form={form} set={set} />
        {(t === "office" || t === "medical" || t === "commercial") && <N label="Arbeitsplätze" k="workplaces" form={form} set={set} step="1" />}
      </div>
      <div className="flex flex-wrap gap-4">
        {(t === "hall" || t === "workshop" || t === "storage") && <><B label="Laderampe" k="has_ramp" form={form} set={set} /><B label="Kranbahn" k="has_crane" form={form} set={set} /></>}
        <B label="Teeküche" k="has_kitchenette" form={form} set={set} />
        <B label="EDV-Verkabelung" k="has_it_cabling" form={form} set={set} />
        <B label="Klimaanlage" k="has_air_conditioning" form={form} set={set} />
      </div>
    </div>
  );
}
